/**
 * @file defines util maps
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

/**
 * Mapping the features whose installation directory can be set
 * to the states that aim to store the directory path.
 * The key is the key of TreeNode in feature selection page
 * The value is the state name
 * @type {Map}
 */

export const featureDirectory2StateMap = new Map([
    ['2', 'webUniversalDeployDirectory'],
    ['2.4', 'gISConnectorsInstallDirectory'],
    ['7', 'communityConnectorsInstallDirectory'],
    ['5.1', 'mobileServerInstallDirectory'],
    ['11', 'commandManagerInstallDirectory'],
    ['12', 'systemManagerInstallDirectory'],
    ['13', 'platformAnalyticsInstallDirectory'],
]);

/**
 * Mapping the features' keys to the states.
 * The key is the key of TreeNode in feature selection page
 * The value is the state name
 * @type {Map}
 */
export const featureKey2StateMap = new Map([
    ['1', 'intelligenceActive'],
    ['1.1', 'distributionServicesActive'],
    ['1.2', 'oLAPServicesActive'],
    ['1.3', 'reportServicesActive'],
    ['1.4', 'transactionServicesActive'],
    ['2.1', 'webReporterActive'],
    ['2.2', 'webAnalystActive'],
    ['2.3', 'webProfessionalActive'],
    ['2.4', 'gISConnectorsActive'],
    ['3', 'repositoryActive'],
    ['4.1', 'libraryWebMobileActive'],
    ['4.2', 'collaborationActive'],
    ['4.3', 'storageServiceActive'],
    ['5.1', 'mobileServerActive'],
    ['6', 'cloudObjectConnectorActive'],
    ['7', 'communityConnectorsActive'],
    ['9', 'telemetryServerActive'],
    ['10', 'integrityManagerActive'],
    ['11', 'commandManagerActive'],
    ['12', 'systemManagerActive'],
    ['13', 'platformAnalyticsActive'],
    ['14', 'certificateStoreActive'],
    ['15', 'enterpriseManagerActive'],
    ['16', 'exportActive'],
    ['17.1', 'tomcatActive'],
]);
